import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type RbidosCommonState = {}

export const rbidosCommonInitialState: RbidosCommonState = {}

export namespace rbidosCommonNS {
	export type InfotecsLogin = PayloadAction<{
		data: Record<string, string>
	}>
}

export const rbidosCommonSlice = createSlice({
	name: 'rbidosCommon',
	initialState: rbidosCommonInitialState,
	reducers: {
		infotecsLogin: (state, action: rbidosCommonNS.InfotecsLogin) => {},
		deleteInfotecsLogin: (state) => {},
	},
})
